import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        VRow,
        [
          _c(
            VCol,
            [
              _c(VRow, [
                _c(
                  "h2",
                  {
                    staticClass:
                      "title primary--text text--darken-1 text-no-wrap mt-0 ml-2",
                  },
                  [_vm._v(" PREFERÊNCIAS DE TRABALHO ")]
                ),
              ]),
              _c(
                VRow,
                [
                  _c(VCol, { attrs: { cols: "12" } }, [
                    _c(
                      "ol",
                      _vm._l(
                        _vm.perfil.perfilPreferencias,
                        function (perfilPreferencia) {
                          return _c(
                            VRow,
                            { key: perfilPreferencia.preferencia.id },
                            [
                              _c(
                                "li",
                                {
                                  staticClass:
                                    "grey--text text--darken-1 font-weight-bold",
                                },
                                [
                                  _c(
                                    VCard,
                                    { attrs: { flat: "" } },
                                    [
                                      _c(
                                        VCardTitle,
                                        {
                                          staticStyle: {
                                            "padding-left": "2px",
                                          },
                                        },
                                        [
                                          _c(
                                            VRow,
                                            { attrs: { "no-gutters": "" } },
                                            [
                                              _c(
                                                "h5",
                                                {
                                                  staticClass:
                                                    "grey--text text--darken-1 text-no-wrap",
                                                },
                                                [
                                                  _vm._v(
                                                    " Qual a sua preferência sobre "
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "secondary--text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            perfilPreferencia
                                                              .preferencia.nome
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _vm._v(" ? "),
                                                ]
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                      _c(
                                        VCardText,
                                        {
                                          staticStyle: { "padding-left": "0" },
                                        },
                                        [
                                          _c(
                                            VRadioGroup,
                                            {
                                              attrs: { row: "" },
                                              on: {
                                                change: function ($event) {
                                                  return _vm.save(
                                                    perfilPreferencia
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  perfilPreferencia
                                                    .itemPreferencia.id,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    perfilPreferencia.itemPreferencia,
                                                    "id",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "perfilPreferencia.itemPreferencia.id",
                                              },
                                            },
                                            [
                                              _c(
                                                "ol",
                                                { staticClass: "ol_itens" },
                                                _vm._l(
                                                  _vm.mapItemOpcoes.get(
                                                    perfilPreferencia
                                                      .preferencia.id
                                                  ),
                                                  function (item) {
                                                    return _c(VRadio, {
                                                      key: item.id,
                                                      attrs: {
                                                        value: item.id,
                                                        "return-object": "",
                                                      },
                                                      scopedSlots: _vm._u(
                                                        [
                                                          {
                                                            key: "label",
                                                            fn: function () {
                                                              return [
                                                                _vm._v(
                                                                  " " +
                                                                    _vm._s(
                                                                      `${item.letra}. ${item.descricao}`
                                                                    ) +
                                                                    " "
                                                                ),
                                                              ]
                                                            },
                                                            proxy: true,
                                                          },
                                                        ],
                                                        null,
                                                        true
                                                      ),
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          )
                        }
                      ),
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }